import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import AdminAllGalleries from "../../Components/Admin/AdminAllGalleries";
import SideBar from "../../Components/Admin/SideBar";

const AdminAllGalariesPage = () => {
  return (
    <AdminAllGalleries />
  );
};

export default AdminAllGalariesPage;
